import { Suspense, lazy } from "react";
import Loader from "@/components/Loader";
import {
  PATH_ACCEPT_INVITE,
  PATH_FORGOT_PASSWORD,
  PATH_LOGIN,
  PATH_LOGOUT,
  PATH_RESET_PASSWORD,
  PATH_SIGNUP,
} from "./paths";

// Lazy like every other route module — eager imports here were bundling the
// whole auth flow (login form, reset/invite containers) into the main chunk
// that authenticated users download on every visit.
const LoginContainer = lazy(() => import("../pages/auth/login/login.container"));
const ForgotPasswordContainer = lazy(
  () => import("@/pages/auth/forgot-password/forgot-password.container")
);
const ResetPasswordContainer = lazy(
  () => import("@/pages/auth/reset-password/reset-password.container")
);
const AcceptInviteContainer = lazy(
  () => import("@/pages/auth/accept-invite/accept.invite.container")
);
const Logout = lazy(() => import("@/pages/logout"));

// These routes render outside any layout, so each element carries its own
// Suspense boundary.
const withSuspense = (element: JSX.Element) => (
  <Suspense fallback={<Loader />}>{element}</Suspense>
);

const authRoutes = [
  {
    path: PATH_LOGIN,
    element: withSuspense(<LoginContainer />),
  },
  {
    path: PATH_SIGNUP,
    element: withSuspense(<LoginContainer />),
  },
  {
    path: PATH_RESET_PASSWORD,
    element: withSuspense(<ResetPasswordContainer />),
  },
  {
    path: PATH_FORGOT_PASSWORD,
    element: withSuspense(<ForgotPasswordContainer />),
  },
  {
    path: PATH_LOGOUT,
    element: withSuspense(<Logout />),
  },
  {
    path: PATH_ACCEPT_INVITE,
    element: withSuspense(<AcceptInviteContainer />),
  },
];

export default authRoutes;
